import { Component, OnInit, OnDestroy, Output, Inject, EventEmitter, ViewChild } from '@angular/core';
import { RECAPTCHA_SETTINGS, RecaptchaSettings, RecaptchaComponent as ReCaptchaComponent } from 'ng-recaptcha';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

export enum KEY_CODE {
  ESC = 27
}

declare global {
  interface Document {
    documentMode?: any;
  }
}

@Component({
  selector: 'idap-recaptcha',
  templateUrl: './recaptcha.component.html',
  styleUrls: ['./recaptcha.component.scss']
})
export class RecaptchaComponent implements OnInit, OnDestroy {
  @Output() captchaResolved: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('captchaRef') captchaRef: ReCaptchaComponent;
  
  resolvedHash: string = '';
  private isExecuting = false;
  private destroy$ = new Subject<void>();
  private executionRequest$ = new Subject<void>();

  constructor(@Inject(RECAPTCHA_SETTINGS) private settings: RecaptchaSettings) {
    this.setupExecutionListener();
  }

  private setupExecutionListener() {
    this.executionRequest$.pipe(
      debounceTime(1000), // Wait 1 second between executions
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.executeCaptcha();
    });
  }

  private async executeCaptcha() {
    if (this.resolvedHash === '' && !this.isExecuting) {
      this.isExecuting = true;
      try {
        await this.captchaRef.execute();
      } finally {
        this.isExecuting = false;
      }
    }
  }

  // Public method to request captcha execution
  public requestCaptchaExecution() {
    this.executionRequest$.next();
  }

  ngOnInit() { }

  ngAfterViewInit() {
    /******** Below are the browser specific checks added for future reference
      // Opera 8.0+
      var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

      // Firefox 1.0+
      var isFirefox = typeof InstallTrigger !== 'undefined';

      // Safari 3.0+ "[object HTMLElementConstructor]" 
      var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

      // Internet Explorer 6-11
      var isIE = /*@cc_on!@*///false || !!document.documentMode;

    // Edge 20+
    //var isEdge = !isIE && !!window.StyleMedia;

    // Chrome 1+
    //var isChrome = !!window.chrome && !!window.chrome.webstore;

    // Blink engine detection
    //var isBlink = (isChrome || isOpera) && !!window.CSS;
    /****************/
    setTimeout(() => {
      if (!!!document.documentMode) {
        this.requestCaptchaExecution();
      } else {
        this.captchaResolved.next(true);
      }
    }, 1000);
  }

  resolved(token: string) {
    this.resolvedHash = token;
    this.captchaResolved.next(true);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.captchaResolved.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/captcha/components/recaptcha.component.ts